jQuery(document).ready(function($) {
    if (window.location.pathname.indexOf('/crossword-puzzles/') > -1 && window.location.pathname !== '/crossword-puzzles/') {
        if ($(window).width() <= 767) {
            if(navigator.userAgent.includes("swiftbot")){
                console.log('its swiftbot');
                return;
            }
            alert('Sorry our Crossword Puzzles are best viewed on devices larger than smartphones.');
        }
    }
});
